import { Create, useForm } from '@refinedev/antd'
import { useNavigate } from 'react-router-dom'
import { Form } from 'antd'
import { ProductFormFields } from './ProductFormFields'

export default function ProductCreatePage() {
  const navigate = useNavigate()

  const { formProps, saveButtonProps } = useForm({
    resource: 'products',
    action: 'create',
    redirect: false,
    onMutationSuccess: (data) => {
      const response = data as unknown as { data: { id: string } }
      navigate(`/products/${response.data.id}`)
    },
  })

  return (
    <Create title="Dodaj proizvod" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <ProductFormFields />
      </Form>
    </Create>
  )
}
